import { configureStore } from '@reduxjs/toolkit';
import authReducer from './reducers/authReducer';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import createTransform from 'redux-persist/es/createTransform';

const savePaidOnly = createTransform(
  (inboundState, key) => {
    if (key === 'hasPaidBefore' && inboundState !== true) {
      return undefined;
    }
    return inboundState;
  },

  (outboundState) => outboundState,
  { whitelist: ['hasPaidBefore', 'paymentStatus'] }
);

const persistConfig = {
  key: 'root',
  storage,
  transforms: [savePaidOnly]
};

const persistedReducer = persistReducer(persistConfig, authReducer);

const store = configureStore({
  reducer: {
    auth: persistedReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
        ignoredPaths: ['register', 'rehydrate']
      }
    })
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
